import { putPasswordsRepositoryLogic } from "./ResetPassword.logic";

export async function updatePasswords(id, params) {
  try {
    const response = await putPasswordsRepositoryLogic(id, params);
    const isSuccess =
      response === true ||
      response?.status === 204 ||
      response?.status === 200 ||
      response?.status === 201;
    if (isSuccess) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}
